// extracted by mini-css-extract-plugin
export default {"Loaders":"Loader_Loaders__TlOcK","spin":"Loader_spin__72oN+","Loaderm":"Loader_Loaderm__UBRJ3","Loaderl":"Loader_Loaderl__wtUdO"};